import axios from 'axios'
import Authentication from '../Authentication'
import EnvUtils from "../utils/EnvUtils";

export default () => {
  return axios.create({
    baseURL: getUrl(),
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': Authentication.getAuthorizationHeader()

    }
  })
}

function getUrl() {
  if (window.env && window.env.get("API_URL")) {
    return window.env.get("API_URL")
  }
  if (EnvUtils.isdev()) {
    return "https://api.dev.caite.io"
  }
  return "https://api.caite.io/"
}
